export default [
  {
    path: '/user-report',
    component: () => import('./views/Index'),
    name: 'user-report',
    redirect: { name: 'user-report-list' },
    children: [
      {
        path: '',
        name: 'user-report-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
